import {
  AnalyticsPageEmployeeNamesFragment,
  AnalyticsPageLegalEntitiesFragment,
  AnalyticsPageLocationsFragment,
  TeamsTeam,
} from 'generated/resources/graphql'

import { countries } from 'modules/core/lib/countryList'

const getCountryCode = (countryName: string) => {
  return (
    countries().find((country) => country.label.toLowerCase() === countryName.toLowerCase())
      ?.value ?? countryName.toLowerCase()
  )
}

export const mapDisplayNameToRawValue = (
  displayName: string | undefined,
  groupBy: string | undefined | null,
  legalEntities?: AnalyticsPageLegalEntitiesFragment[],
  teams?: Pick<TeamsTeam, 'id' | 'name'>[],
  locations?: AnalyticsPageLocationsFragment[],
  employeesNames?: AnalyticsPageEmployeeNamesFragment[]
): string | number | AnalyticsPageEmployeeNamesFragment | undefined => {
  if (!groupBy) return displayName?.toLowerCase()

  switch (groupBy) {
    case 'legal_entity':
      return (
        legalEntities?.find(
          (entity) => entity.legalName.toLowerCase() === displayName?.toLowerCase()
        )?.id ?? displayName?.toLowerCase()
      )
    case 'team':
      return (
        teams?.find((team) => team.name.toLowerCase() === displayName?.toLowerCase())?.id ??
        displayName?.toLowerCase()
      )
    case 'workspace':
      return (
        locations?.find((location) => location.name.toLowerCase() === displayName?.toLowerCase())
          ?.id ?? displayName?.toLowerCase()
      )
    case 'manager':
      return employeesNames?.find(
        (employee) => employee.fullName.toLowerCase() === displayName?.toLowerCase()
      )
    case 'nationality':
      return getCountryCode(displayName ?? '')
    case 'gender':
      return displayName?.toLowerCase()
    default:
      return displayName?.toLowerCase()
  }
}
